import { Component, OnInit, Input, SimpleChanges, ViewChild, Output, EventEmitter, forwardRef } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule, Validators, ValidatorFn } from '@angular/forms';
import { 
    IonModal, IonContent, IonSpinner, IonGrid, IonRow, IonCol, IonIcon, AlertController, ToastController
} from '@ionic/angular/standalone';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import moment from 'moment';

import { MarvDateService, MarvWeekDay, MarvValidatorsService, MarvModalService } from '@marv/services';
import { 
    MarvCardComponent, MarvSectionTitleComponent, MarvButtonComponent, MarvMessageComponent, MarvDrawerComponent,
    MarvInputComponent, MarvTextareaComponent, MarvSelectItem, MarvSelectComponent, MarvInputDateComponent, MarvInputTimeComponent, 
    MarvToggleComponent, MarvSubItemComponent, MarvInputFile, MarvInputFileComponent, MarvCheckboxComponent, MarvRadioComponent,
    MarvCircleComponent
} from '@marv/components';
import { MarvDateToStringPipe } from '@marv/pipes';
import { OrderService, LoggedUserService, OperationService, StoreService } from '@app/services';
import { 
    StoreItem, StoreItemComponent, StoreDetailsTab, StoreListComponent, StoreDetailsComponent, DatesPreview, DatesPreviewComponent,
    OrderDay, OrderDayStore, OrderDayDateConf, MissionAdditionalDataComponent
} from '@app/components';
import { 
    Operation, OperationCustomerPlanningSetting, MerchImplementationOption, OrderRequest, Store, FTSector,
    MissionPlanningComplianceReport, CustomerOrderQuota 
} from '@app/models';
import { environment } from '@app/environment';

class MultipleGoal{
    id: number;
    name: string;
}

class OrderDayProcessStatus {   
    ordersIds: Array<number> = [];
    error: boolean = true;
    msgError: string = '';
}

@Component({
    selector: 'app-add-day',
    templateUrl: './add-day.component.html',
    styleUrls: ['./add-day.component.scss'],
    imports: [
        IonModal, IonContent, IonSpinner, IonGrid, IonRow, IonCol, IonIcon, TranslatePipe, ReactiveFormsModule, MarvDateToStringPipe,
        forwardRef(() => MarvDrawerComponent),  forwardRef(() => MarvCardComponent), forwardRef(() => MarvSectionTitleComponent), 
        forwardRef(() => MarvButtonComponent), forwardRef(() => MarvMessageComponent), forwardRef(() => MarvInputComponent), 
        forwardRef(() => MarvTextareaComponent), forwardRef(() => MarvSelectComponent), forwardRef(() => MarvInputDateComponent), 
        forwardRef(() => MarvInputTimeComponent), forwardRef(() => MarvToggleComponent), forwardRef(() => MarvSubItemComponent), 
        forwardRef(() => MarvInputFileComponent), forwardRef(() => MarvCheckboxComponent), forwardRef(() => MarvRadioComponent),
        forwardRef(() => MarvCircleComponent), 
        forwardRef(() => StoreItemComponent), forwardRef(() => StoreListComponent), forwardRef(() => StoreDetailsComponent), 
        forwardRef(() => DatesPreviewComponent), forwardRef(() => MissionAdditionalDataComponent)
    ]
})
export class MissionAddDayComponent  implements OnInit {

    @Input({alias : 'operation', required : true}) operation: Operation;  
    @Input({alias : 'operationPlanningSetting', required : true}) operationPlanningSetting: OperationCustomerPlanningSetting;  
    @Input({alias : 'storeId', required : false}) storeId: number|null = null;  
    @Input({alias : 'orderDay', required : true}) orderDay: OrderDay;  
    @Output() onChangeOrderDay = new EventEmitter<OrderDay|null>();
    
    @ViewChild('drawerStoresList') drawerStoresList: MarvDrawerComponent;
    @ViewChild('drawerStore') drawerStore: MarvDrawerComponent;
    @ViewChild('modalDatesPreview') modalDatesPreview: IonModal;
    @ViewChild('modalAdditionalsDatas') modalAdditionalsDatas: IonModal;
    
    environment = environment;
        
    isLoggedUserAllowedToPlan: boolean = false;
    isFetchingStore: boolean = false;
    store: Store|null = null;
    storeItem: StoreItem|null = null;
    storeDetailsTab: StoreDetailsTab = 'infos';
    
    disabledForm: boolean = false;
    disabledUpdate: boolean = false;
    addOrderDayForm: FormGroup = new FormGroup({
        nbDays: new FormControl(null, [Validators.required]),        
        nbAgents: new FormControl(null, [Validators.required, Validators.min(1)]), 
        enableRecurrence: new FormControl(false),        
        enableMissionBrief: new FormControl(true),
        missionDetailsFile: new FormControl(null), 
    });
    displayAdditionalsDatas: boolean = false;
    additionalsDatas: any = null;
    additionalsDatasUpdated: boolean = false;
    lastModificationAdditionalsDatas: Date|null = null;
    showMsgSelectPurpose: boolean = false;
   
    isFetchingSave: boolean = false;
    days: Array<MarvSelectItem> = [];   
    durations: Array<MarvSelectItem> = [];   
    missionDetailsFile: MarvInputFile|null = null;    
    missionDetailsFileExt: Array<string> = ['pdf'];
    startPlannableDate: Date;
    endPlannableDate: Date;
    planningComplientReport: MissionPlanningComplianceReport = new MissionPlanningComplianceReport();
    orderPlanningRules: Array<string> = [];
    dayOrderDurationEstimated: number = 0;
    dayOrderDurationEstimatedStr: string = '';
    dayOrderEndHourEstimatedStr: string = '';
    enforceDayOrderDuration: boolean = false;
    enforceDayOrderDurationEstimated: boolean = false;
    nbWorkersRecommended: number = 0;
    periodicityRecurrence: Array<MarvSelectItem> = [
        new MarvSelectItem(this.translateService.instant('WEEKLY'), 1), 
        new MarvSelectItem(this.translateService.instant('MONTHLY'), 2)
    ]; 
    weekDays: Array<MarvWeekDay> = MarvDateService.GetWeekDays(); 
    weekDaysItems: Array<MarvSelectItem> = [];   
    recurrenceMonthDay: Array<MarvSelectItem> = [
        new MarvSelectItem(this.translateService.instant('FIRST'), 1),
        new MarvSelectItem(this.translateService.instant('SECOND'), 2),
        new MarvSelectItem(this.translateService.instant('THIRD'), 3),
        new MarvSelectItem(this.translateService.instant('FOURTH'), 4),
        new MarvSelectItem(this.translateService.instant('LAST'), 5),
    ];   
    kits: Array<MarvSelectItem> = [];   
    merchImplementationOptions: Array<MarvSelectItem> = [];   
    uniqueGoals: Array<MarvSelectItem> = [];   
    multipleGoals: Array<MultipleGoal> = [];
    agentsProfils: Array<MarvSelectItem> = [];
    numsDates: Array<number> = [];
    numsAgents: Array<number> = [];
    showWorkersSuggestionList: boolean = false;
    workersSuggestionItem: Array<MarvSelectItem> = [];
    workersSuggestionMessageInfo: string = '';
    hoursEntrySelected: Map<number, 'IMPOSED'|'SUGGESTED'> = new Map();
    datesPreview: DatesPreview = new DatesPreview();
    contactSharingToWorkerAllowed: boolean = false;
    updateEnableRecurrenceSubscription: Subscription;
    updateNbDaysSubscription: Subscription;
    updateDaySubscription: Map<number, Subscription> = new Map<number, Subscription>;
    updateRecurrencePeriodicitySubscription: Map<number, Subscription> = new Map<number, Subscription>;
    updateRecurrenceStartDateSubscription: Map<number, Subscription> = new Map<number, Subscription>;
    updateRecurrenceEndDateSubscription: Map<number, Subscription> = new Map<number, Subscription>;
    updateWeeklyRecurrenceSubscription: Map<number, Subscription> = new Map<number, Subscription>;
    updateWeeklyRecurrenceDaySubscription: Map<string, Subscription> = new Map<string, Subscription>;    
    updateMonthlyRecurrenceNumDaySubscription: Map<number, Subscription> = new Map<number, Subscription>;
    updateMonthlyRecurrenceDaySubscription: Map<number, Subscription> = new Map<number, Subscription>;
    updateMonthlyRecurrenceMonthSubscription: Map<number, Subscription> = new Map<number, Subscription>;    
    updateStartTimeMinSubscription: Map<number, Subscription> = new Map<number, Subscription>;
    updateStartTimeMaxSubscription: Map<number, Subscription> = new Map<number, Subscription>;
    updateTimeMorningSubscription: Map<number, Subscription> = new Map<number, Subscription>;
    updateDurationMorningSubscription: Map<number, Subscription> = new Map<number, Subscription>;
    updateTimeAfternoonSubscription: Map<number, Subscription> = new Map<number, Subscription>;
    updateDurationAfternoonSubscription: Map<number, Subscription> = new Map<number, Subscription>;
    updateNbAgentsSubscription: Subscription;
    updateMerchImplementationOptionsSubscription: Subscription;
    updateGoalsSubscription: Subscription;

    constructor(
        public translateService: TranslateService,
        private alertController: AlertController,
        private toastController: ToastController,
        private marvModalService: MarvModalService,
        private loggedUserService: LoggedUserService,
        private orderService: OrderService,
        private operationService: OperationService,
        private storeService: StoreService
    ) { 
       
    }

    ngOnInit() {
        
        this.isLoggedUserAllowedToPlan = (this.loggedUserService.loggedUser?.customerPlanningAllowed === true);
        
        this.weekDays.forEach(w => {
            this.weekDaysItems.push(new MarvSelectItem(w.name, w.numDay));
        });
        
        let loggedUser = this.loggedUserService.loggedUser ;
        if(loggedUser && loggedUser.contactSharingToWorkerAllowed){
            this.contactSharingToWorkerAllowed = true;
        }        
        
        this.updateEnableRecurrenceSubscription = this.addOrderDayForm.controls['enableRecurrence'].valueChanges.subscribe(value => {
            let periodicityDates: Map<number, number> = new Map<number, number>;            
            this.toggleRecurrence(this.addOrderDayForm.controls['enableRecurrence'].value, periodicityDates);
        });
        
        this.updateNbDaysSubscription = this.addOrderDayForm.controls['nbDays'].valueChanges.subscribe(value => {             
            this.setNbDaysForm(this.addOrderDayForm.controls['nbDays'].value, this.addOrderDayForm.controls['enableRecurrence'].value);            
            this.checkDateValue();
        });
         
        this.updateNbAgentsSubscription = this.addOrderDayForm.controls['nbAgents'].valueChanges.subscribe(value => {            
           this.setNbAgentsForm(this.addOrderDayForm.controls['nbAgents'].value);
        });
        
    }    
    
    ngOnDestroy() {     
      
        if(this.updateEnableRecurrenceSubscription){
            this.updateEnableRecurrenceSubscription.unsubscribe();
        }
      
        if(this.updateNbDaysSubscription){
            this.updateNbDaysSubscription.unsubscribe();
        }
        
        this.updateDaySubscription.forEach(s => {
            s.unsubscribe();
        });
        this.updateDaySubscription.clear();
        
        this.updateRecurrencePeriodicitySubscription.forEach(s => {
            s.unsubscribe();
        });
        this.updateRecurrencePeriodicitySubscription.clear();
        
        this.updateRecurrenceStartDateSubscription.forEach(s => {
            s.unsubscribe();
        });
        this.updateRecurrenceStartDateSubscription.clear();
        
        this.updateRecurrenceEndDateSubscription.forEach(s => {
            s.unsubscribe();
        });
        this.updateRecurrenceEndDateSubscription.clear();
        
        this.updateWeeklyRecurrenceSubscription.forEach(s => {
            s.unsubscribe();
        });
        this.updateWeeklyRecurrenceSubscription.clear();
        
        this.updateWeeklyRecurrenceDaySubscription.forEach(s => {
            s.unsubscribe();
        });
        this.updateWeeklyRecurrenceDaySubscription.clear();
        
        this.updateMonthlyRecurrenceNumDaySubscription.forEach(s => {
            s.unsubscribe();
        });
        this.updateMonthlyRecurrenceNumDaySubscription.clear();
        
        this.updateMonthlyRecurrenceDaySubscription.forEach(s => {
            s.unsubscribe();
        });
        this.updateMonthlyRecurrenceDaySubscription.clear();
        
        this.updateMonthlyRecurrenceMonthSubscription.forEach(s => {
            s.unsubscribe();
        });
        this.updateMonthlyRecurrenceMonthSubscription.clear();
        
        this.updateStartTimeMinSubscription.forEach(s => {
            s.unsubscribe();
        });
        this.updateStartTimeMinSubscription.clear();
        
        this.updateStartTimeMaxSubscription.forEach(s => {
            s.unsubscribe();
        });
        this.updateStartTimeMaxSubscription.clear();
        
        this.updateTimeMorningSubscription.forEach(s => {
            s.unsubscribe();
        });
        this.updateTimeMorningSubscription.clear();
        
        this.updateDurationMorningSubscription.forEach(s => {
            s.unsubscribe();
        });
        this.updateDurationMorningSubscription.clear();
        
        this.updateTimeAfternoonSubscription.forEach(s => {
            s.unsubscribe();
        });
        this.updateTimeAfternoonSubscription.clear();
        
        this.updateDurationAfternoonSubscription.forEach(s => {
            s.unsubscribe();
        });
        this.updateDurationAfternoonSubscription.clear();

        if(this.updateNbAgentsSubscription){
            this.updateNbAgentsSubscription.unsubscribe();
        }
        if(this.updateGoalsSubscription){
            this.updateGoalsSubscription.unsubscribe();
        }
        if(this.updateMerchImplementationOptionsSubscription){
            this.updateMerchImplementationOptionsSubscription.unsubscribe();
        }
    }    
    
    async ngOnChanges(changes: SimpleChanges) {
        
        if(changes['operation']){     
        
            let kits: Array<MarvSelectItem> = [];
            let agentsProfils: Array<MarvSelectItem> = [];
            this.displayAdditionalsDatas = false;
            
            if(this.operation){
                if(this.operation.typeOfMission.code != environment.MISSION_TYPE_ANIM){
                    this.addOrderDayForm.addControl('enableStoreContact', new FormControl(false), {emitEvent: false});        
                    this.addOrderDayForm.addControl('storeContactName', new FormControl(null), {emitEvent: false});        
                    this.addOrderDayForm.addControl('storeContactPhone', new FormControl(null), {emitEvent: false});        
                    this.addOrderDayForm.addControl('storeContactAccess', new FormControl(null), {emitEvent: false});   
                    this.addOrderDayForm.addControl('enableCustomerAppointment', new FormControl(false), {emitEvent: false});        
                    this.addOrderDayForm.addControl('sharingCustomerSectorContactDetailsToWorker', new FormControl(false), {emitEvent: false});        
                    this.addOrderDayForm.addControl('customerAppointmentPlace', new FormControl(null), {emitEvent: false});        
                    this.addOrderDayForm.addControl('customerAppointmentTime', new FormControl(null), {emitEvent: false});    
                }

                this.operation.listActiveProfiles().forEach(p => {
                    agentsProfils.push(new MarvSelectItem(p.name, p.id));
                });
                
                if(this.operationPlanningSetting?.choseKitOnCustomerMissionPlaning){
                    this.operation.findActiveKits().forEach(k => {
                        kits.push(new MarvSelectItem(k.name, k.id));
                    });
                } 
                
                // A MODIFIER - Pour l'affichage des vitrines Coca 
                this.displayAdditionalsDatas = (this.operation.id === 2028);      
            }
                             
            if(kits.length > 0){
                this.addOrderDayForm.addControl('kit', new FormControl((kits.length === 1 ? kits[0].value : null)), {emitEvent: false});   
            }
            else{
                this.addOrderDayForm.removeControl('kit', {emitEvent: false}); 
            }
            
            this.kits = kits;
            this.agentsProfils = agentsProfils;
        }
        
        if(changes['operationPlanningSetting']){   
                         
            let days: Array<MarvSelectItem> = [];   
            let merchImplementationOptions: Array<MarvSelectItem> = [];
            let uniqueGoals: Array<MarvSelectItem> = [];
            let multipleGoals: Array<MultipleGoal> = [];            
            let orderPlanningRules: Array<string> = [];  
            let startPlannableDate: Date = new Date();
            let endPlannableDate: Date = moment().add(180, 'days').toDate();
            this.dayOrderDurationEstimated = 0;
            this.dayOrderDurationEstimatedStr = '';
            this.enforceDayOrderDuration = false;
            
            this.initDurations();
            
            if(this.updateGoalsSubscription){
                this.updateGoalsSubscription.unsubscribe();
            }
            
            if(this.updateMerchImplementationOptionsSubscription){
                this.updateMerchImplementationOptionsSubscription.unsubscribe();
            }
            
            if(this.operationPlanningSetting){
                
                if(this.operationPlanningSetting.mandatoryMissionDurationInHours){
                    this.enforceDayOrderDuration = true;
                }
                
                if(this.operationPlanningSetting.merchImplementationOptions?.length > 0){
                    
                    this.addOrderDayForm.addControl('merchImplementationOption', new FormControl(null), {emitEvent: false});
                    this.updateMerchImplementationOptionsSubscription = this.addOrderDayForm.controls['merchImplementationOption'].valueChanges.subscribe(value => {            
                        this.prefillNbAgents();
                    });
                    
                    this.operationPlanningSetting.merchImplementationOptions.forEach(e => {
                        merchImplementationOptions.push(new MarvSelectItem(e.name, e.id));
                    });
                }
              
                if(this.operationPlanningSetting.missionPlanningPurposes?.length > 0){
                    if(this.operationPlanningSetting.useMultiPurposePlanning){
                        this.operationPlanningSetting.missionPlanningPurposes.forEach(p => {

                            this.addOrderDayForm.addControl('enableMultipleGoal_'+p.id, new FormControl(false), {emitEvent: false});
                            this.addOrderDayForm.addControl('multipleGoalComments_'+p.id, new FormControl(null), {emitEvent: false});
                            this.updateGoalsSubscription = this.addOrderDayForm.controls['enableMultipleGoal_'+p.id].valueChanges.subscribe(value => {  
                                this.checkPurposePlanning();
                                this.calculateEstimatedTime();
                            });

                            multipleGoals.push({
                                id: p.id,
                                name: p.name
                            });
                        });
                    } 
                    else {
                        let uniqueGoalValidators: Array<ValidatorFn> = [];
                        if(this.operationPlanningSetting.mandatoryMissionPurposeOnPlanning){
                            uniqueGoalValidators.push(Validators.required);
                        }
                        this.addOrderDayForm.addControl('uniqueGoal', new FormControl(null, uniqueGoalValidators), {emitEvent: false});
                        this.addOrderDayForm.addControl('uniqueGoalComments', new FormControl(null), {emitEvent: false});
                        this.updateGoalsSubscription = this.addOrderDayForm.controls['uniqueGoal'].valueChanges.subscribe(value => {      
                            this.checkPurposePlanning();                             
                            this.calculateEstimatedTime();    
                        });

                        this.operationPlanningSetting.missionPlanningPurposes.forEach(p => {
                            uniqueGoals.push(new MarvSelectItem(p.name, p.id));
                        });
                    }
                }
                
                startPlannableDate = new Date();  
                if(this.operationPlanningSetting.earliestPlannableDate){
                    let d = MarvDateService.ToDate(this.operationPlanningSetting.earliestPlannableDate);
                    if(d && moment(d).format('YYYY-MM-DD') > moment(startPlannableDate).format('YYYY-MM-DD')){
                        startPlannableDate = d;   
                    }                    
                }   
                             
                if(this.operationPlanningSetting.latestPlannableDate){
                    let d = MarvDateService.ToDate(this.operationPlanningSetting.latestPlannableDate);
                    if(d){
                        endPlannableDate = d;                        
                    }
                }
                
                if(endPlannableDate){
                    orderPlanningRules.push(this.translateService.instant('MSG_RULE_PERIOD_PLANNABLE_DATE')
                    .replace('#start_date#', moment(startPlannableDate).format('DD/MM/YYYY'))
                    .replace('#end_date#', moment(endPlannableDate).format('DD/MM/YYYY')));
                }
                else{
                    orderPlanningRules.push(this.translateService.instant('MSG_RULE_START_PLANNABLE_DATE').replace('#date#', moment(startPlannableDate).format('DD/MM/YYYY')));
                }
                
                if(this.operationPlanningSetting.needCustomerApprovalPlannedBefore){
                    orderPlanningRules.push(this.translateService.instant('MSG_RULE_NB_PLANNED_DAYS_BEFORE').replace('#nb_days#', this.operationPlanningSetting.needCustomerApprovalPlannedBefore)); 
                }     
                
                if(this.operationPlanningSetting.nbOfConsecutivePlannedDays > 0){
                    orderPlanningRules.push(this.translateService.instant('MSG_RULE_NB_CONSECUTIVE_PLANNED_DAYS').replace('#nb_days#', this.operationPlanningSetting.nbOfConsecutivePlannedDays));
                    days.push(new MarvSelectItem(this.operationPlanningSetting.nbOfConsecutivePlannedDays.toString(), this.operationPlanningSetting.nbOfConsecutivePlannedDays));                    
                }  
                else{
                    for(let i=1;i<=10;i++){
                        days.push(new MarvSelectItem(i.toString(), i));
                    }                   
                }   
                              
            }
            
            if(uniqueGoals.length > 0 || multipleGoals.length > 0 || merchImplementationOptions.length > 0){
                this.addOrderDayForm.addControl('enableGoals', new FormControl(true), {emitEvent: false});
            }
            else{
                this.addOrderDayForm.removeControl('enableGoals', {emitEvent: false});
            }
                    
            this.days = days;
            this.merchImplementationOptions = merchImplementationOptions;
            this.uniqueGoals = uniqueGoals;
            this.multipleGoals = multipleGoals;
            this.orderPlanningRules = orderPlanningRules;
            this.startPlannableDate = startPlannableDate;
            this.endPlannableDate = endPlannableDate;
        }
        
        if(changes['orderDay']){          
          
            let missionDetailsFile: MarvInputFile|null = null;             
            this.disabledForm = false;
            this.disabledUpdate = false;            
            this.nbWorkersRecommended = 0;
            this.datesPreview = new DatesPreview();
            
            this.store = null;
            this.storeItem = null;
            this.hoursEntrySelected.clear();
            
            this.additionalsDatas = null;
            this.additionalsDatasUpdated = false;
            this.lastModificationAdditionalsDatas = null;
            
            if(changes['orderDay'].currentValue && this.orderDay){
                
                let nbDays = (this.operationPlanningSetting.nbOfConsecutivePlannedDays > 0 ? this.operationPlanningSetting.nbOfConsecutivePlannedDays : this.orderDay.nbDays);
                let defautTime = this.getTimeFix();
                this.disabledUpdate = (this.orderDay.orderId !== undefined);
                
                let values: any = {     
                    nbDays: nbDays,         
                    nbAgents: this.orderDay.nbAgents,                                           
                    enableRecurrence: this.orderDay.enableRecurrence,                                       
                    enableMissionBrief: this.orderDay.enableMissionBrief,  
                    missionDetailsFile: null              
                };  
                let periodicityDates: Map<number, number> = new Map<number, number>;   
                
                if(this.uniqueGoals.length > 0 || this.multipleGoals.length > 0 || this.merchImplementationOptions.length > 0){
                    values.enableGoals = this.orderDay.enableGoals;
                }                           
                                
                this.setNbDaysForm(nbDays, this.orderDay.enableRecurrence, this.orderDay.datesConf);
                              
                for(let i=0;i<nbDays;i++){
                    
                    let numDate = (i+1);
                    let exist = (this.orderDay.datesConf[i] ? this.orderDay.datesConf[i] : null);   
                    
                    if(this.orderDay.enableRecurrence){
                        
                        let periodicity = (exist?.recurrence ? exist.recurrence.periodicity : 1);
                        values['recurrence_start_date_'+numDate] = (exist?.recurrence ? exist.recurrence.startDate : null);
                        values['recurrence_end_date_'+numDate] = (exist?.recurrence ? exist.recurrence.endDate : null);
                        values['periodicity_'+numDate] = periodicity;   
                        periodicityDates.set(numDate, periodicity);          
                        this.addOrderDayForm.removeControl('day_'+numDate, {emitEvent: false});
                        
                        switch(periodicity){
                            case 1:
                                values['weekly_recurrence_'+numDate] = (exist?.recurrence?.recurrenceWeekly ? exist.recurrence.recurrenceWeekly.weeklyRecurrence : null);
                                for(let wd of this.weekDays){
                                    values['weekly_day_'+numDate+'_'+wd.numDay] = (exist?.recurrence?.recurrenceWeekly ? exist?.recurrence?.recurrenceWeekly.weeklyDays.indexOf(wd.numDay) !== -1 : false);
                                }                               
                                break;
                            case 2:
                                values['monthly_recurrence_day_num_'+numDate] = (exist?.recurrence?.recurrenceMonthly ? exist.recurrence.recurrenceMonthly.monthlyRecurrenceDayNum : null);
                                values['monthly_recurrence_day_'+numDate] = (exist?.recurrence?.recurrenceMonthly ? exist.recurrence.recurrenceMonthly.monthlyRecurrenceDay : null);
                                values['monthly_recurrence_month_'+numDate] = (exist?.recurrence?.recurrenceMonthly ? exist.recurrence.recurrenceMonthly.monthlyRecurrenceMonth : null);                                
                                break;
                        }
                    }
                    else{       
                        values['day_'+numDate] = (exist ? exist.date.day : null);
                    }
                    
                    let amDuration = defautTime.amDuration
                    if(this.operation.typeOfMission.code != environment.MISSION_TYPE_ANIM){
                        if(this.operationPlanningSetting?.mandatoryMissionDurationInHours){
                            amDuration = this.operationPlanningSetting.mandatoryMissionDurationInHours*60;
                        }
                        else if(amDuration === null && this.dayOrderDurationEstimated > 0){
                            amDuration = this.dayOrderDurationEstimated;
                        }
                    }
                    
                    let hoursEntry: 'IMPOSED'|'SUGGESTED' = (exist ? exist.date.hoursEntry : 'IMPOSED');
                    values['startTimeMin_'+numDate] = (exist ? exist.date.startTimeMin : null);
                    values['startTimeMax_'+numDate] = (exist ? exist.date.startTimeMax : null);
                    
                    values['timeMorning_'+numDate] = (exist ? exist.date.timeMorning : defautTime.amStartTime);
                    values['durationMorning_'+numDate] = (exist ? exist.date.durationMorning : amDuration);
                    values['timeAfternoon_'+numDate] = (exist ? exist.date.timeAfternoon : defautTime.pmStartTime);
                    values['durationAfternoon_'+numDate] = (exist ? exist.date.durationAfternoon : defautTime.pmDuration);
                                   
                    values['hoursEntry_'+numDate] = hoursEntry;
                    this.hoursEntrySelected.set(numDate, hoursEntry);                    
                    this.setValidatorsHours(numDate);     
                }
               
                if(this.kits.length > 0){
                    values['kit'] = this.orderDay.kit;
                } 
                
                let nbAgents = (this.orderDay.nbAgents || 0);
                if(this.operationPlanningSetting.merchImplementationOptions.length > 0){
                    let idElement: number|null = null;
                    if(this.orderDay.merchImplementationOption){
                        let exist = this.operationPlanningSetting.merchImplementationOptions.find(e => e.id === this.orderDay.merchImplementationOption);
                        if(exist){  
                            idElement = exist.id;       
                            if(exist.suggestedNbOfAgents > 0){
                                this.nbWorkersRecommended = exist.suggestedNbOfAgents;  
                            }                   
                        }
                        
                    }
                    values['merchImplementationOption'] = idElement;
                }
                this.setNbAgentsForm(nbAgents);
                
                for(let i=0;i<nbAgents;i++){
                    let numAgent = (i+1);
                    let exist = (this.orderDay.agents[i] ? this.orderDay.agents[i] : null);               
                    values['agentProfil_'+numAgent] = (exist ? exist.profilId : null);     
                    values['agentsSuggestionIds_'+numAgent] = (exist?.workersSuggestionIds ? exist.workersSuggestionIds : []);     
                    values['agentSuggestion_'+numAgent] = (exist ? exist.suggestion : null);
                }   
                
                if(this.operationPlanningSetting && this.operationPlanningSetting.missionPlanningPurposes?.length > 0){
                    if(this.operationPlanningSetting.useMultiPurposePlanning){
                        this.operationPlanningSetting.missionPlanningPurposes.forEach(p => {
                            let exist = this.orderDay?.multipleGoals.find(g => g.goalId === p.id);
                            values['enableMultipleGoal_'+p.id] = (exist ? true : false);
                            values['multipleGoalComments_'+p.id] = (exist ? exist.comments : null);                        
                        });
                    }      
                    else {
                        values.uniqueGoal = this.orderDay.uniqueGoal;                    
                        values.uniqueGoalComments = this.orderDay.uniqueGoalComments;                    
                    }                     
                }
                
                if(this.operation.typeOfMission.code != environment.MISSION_TYPE_ANIM){
                    values['enableStoreContact'] = this.orderDay.enableStoreContact;
                    values['storeContactName'] = this.orderDay.storeContactName;
                    values['storeContactPhone'] = this.orderDay.storeContactPhone;
                    values['storeContactAccess'] = this.orderDay.storeContactAccess;
                    values['enableCustomerAppointment'] = this.orderDay.enableCustomerAppointment;
                    values['sharingCustomerSectorContactDetailsToWorker'] = this.orderDay.sharingCustomerSectorContactDetailsToWorker;
                    values['customerAppointmentPlace'] = this.orderDay.customerAppointmentPlace;
                    values['customerAppointmentTime'] = this.orderDay.customerAppointmentTime;
                }
                
                this.toggleRecurrence(this.orderDay.enableRecurrence, periodicityDates);
                this.addOrderDayForm.setValue(values, {emitEvent: false});
                                
                if(this.orderDay.missionDetailsFile){
                    missionDetailsFile = this.orderDay.missionDetailsFile;
                }
                
                let storeId = (this.orderDay.store !== null ? this.orderDay.store.id : (this.storeId !== null ? this.storeId : null))
                if(storeId){
                    await this.getStoreDetails(storeId);
                }   
                
                await this.getWorkersSuggestionList();              
                
                if(!this.orderDay.disabled){
                    this.checkPurposePlanning();
                    this.calculateEstimatedTime();            
                }
                else{         
                    this.disabledForm = true;
                }
                this.datesPreview = this.orderDay.datesPreview;
                this.checkDateValue();
                
                if(this.displayAdditionalsDatas && this.orderDay.orderId){
                    this.additionalsDatas = await this.orderService.loadAdditionalsDatas(this.orderDay.orderId); 
                    if(this.additionalsDatas){
                        this.lastModificationAdditionalsDatas = moment.unix(this.additionalsDatas.last_modification).utc().toDate();
                    }
                }
                
            }                       
            this.missionDetailsFile = missionDetailsFile;
        }
        
        if(changes['storeId']){
            if(this.orderDay.store === null){
                await this.getStoreDetails(this.storeId);
            }
        }
    }
    
    initDurations(){        
        let durations: Array<MarvSelectItem> = [];        
        let minHour = 0;
        // A MODIFIER - Mis en dur pour COCA & merch ponctuel
        if(this.operation.id == 2029){
            minHour = 2;
        }
        for(let i=minHour;i<=7;i++){
            if(i>0){
                durations.push(new MarvSelectItem(i+"H00", i*60));
            }  
            if(i<7){
                durations.push(new MarvSelectItem(i+"H30", (i*60)+30));
            }                      
        }        
        this.durations = durations;
    }
    
    async getStoreDetails(storeId: number|null){
        this.isFetchingStore = true;
        let store: Store|null = null;
        let storeItem: StoreItem|null = null;
        let orderDayStore: OrderDayStore|null = null;
        if(storeId && MarvValidatorsService.isInteger(storeId)){           
            let storeDashboard = await this.storeService.loadStoreDashboard(storeId);   
            if(storeDashboard?.store){
                store = storeDashboard.store;
                storeItem = StoreItem.FromStore(storeDashboard?.store);
                orderDayStore = new OrderDayStore(store.id, store.name, store.retailerName);
            }            
        }   
        this.store = store;
        this.storeItem = storeItem;
        this.orderDay.store = orderDayStore;
        this.orderDay.customerSectorId = (store?.customerSectorId ? store.customerSectorId  : null);
        this.isFetchingStore = false; 
    }
    
    openStoresDrawer() {
        this.drawerStoresList.open();
    }
    
    async loadAdditionalsDatasStore(){
        if(this.store){
            this.additionalsDatas = await this.storeService.loadAdditionalsDatas(this.operation.id, this.store.id);
            if(this.additionalsDatas){
                this.lastModificationAdditionalsDatas = moment.unix(this.additionalsDatas.last_modification).utc().toDate();
            }
        }
    }
    
    async onSelectStore(storeItem: StoreItem){
        this.drawerStoresList.close(false);
        await this.getStoreDetails(storeItem.id);
        await this.getWorkersSuggestionList(); 
        this.lastModificationAdditionalsDatas = null;
        if(this.displayAdditionalsDatas){
            await this.loadAdditionalsDatasStore();
        }
    }
    
    onDidDismissDrawerStoresList($event: any){
        if($event.detail?.data?.resetDrawer){
            
        }               
    }
    
    showAdditionalsDatasStore(){
        this.openAdditionalsDatasModal();
    }   
    
    unselectStore(storeItem: StoreItem){
        this.store = null;
        this.storeItem = null;
        this.additionalsDatas = null;
        this.additionalsDatasUpdated = false;
        this.lastModificationAdditionalsDatas = null;
        this.showWorkersSuggestionList = false;
        this.workersSuggestionItem = [];
        this.workersSuggestionMessageInfo = '';
    }   
    
    openStoreDrawer(){
        this.drawerStore.open();
    }
    
    async onDidDismissDrawerStore($event: any){
        this.storeDetailsTab = 'infos';
        if(this.displayAdditionalsDatas){
            await this.loadAdditionalsDatasStore();
            this.displayAdditionalsDatas = false;            
            setTimeout(() => {
                this.displayAdditionalsDatas = true;
            });
        }
    }
    
    checkPurposePlanning(){
        let checkPurposePlanning: boolean = true;
        if(this.operationPlanningSetting.mandatoryMissionPurposeOnPlanning){
            if(this.operationPlanningSetting.useMultiPurposePlanning){
                let hasPurposesChecked: boolean = false;
                this.operationPlanningSetting.missionPlanningPurposes.forEach(p => {
                    if(this.addOrderDayForm.controls['enableMultipleGoal_'+p.id].value){
                        hasPurposesChecked = true;
                    }
                });
                checkPurposePlanning = hasPurposesChecked;
            }
            else{
                checkPurposePlanning = (this.addOrderDayForm.controls['uniqueGoal'].value !== null);  
            }
        }
        this.showMsgSelectPurpose = (checkPurposePlanning !== true);
        return checkPurposePlanning;
    }
    
    openDatesPreviewModal(){        
        this.marvModalService.open(this.modalDatesPreview);
    }
    
    closeDatesPreviewModal(){
        this.modalDatesPreview.dismiss();
    }
    
    async canDismissDatesPreviewModal(data?: any, role?: string) {
        return role !== 'gesture';
    }
    
    onDidDismissDatesPreviewModal($event: any){
        this.marvModalService.onDidDismiss($event);
    }
    
    onChangeDatesPreview(updatedDates: DatesPreview|null){
        if(updatedDates !== null){
            this.datesPreview = updatedDates;
            this.checkDateValue();
        }
        this.closeDatesPreviewModal();
    }
        
    isDateEnabled = (dateString: string) => {
        let date = moment(new Date(dateString));
        if(this.startPlannableDate && this.endPlannableDate){
            let start = moment(this.startPlannableDate);
            let end = moment(this.endPlannableDate);
            return (start.format('YYYY-MM-DD') <= date.format('YYYY-MM-DD') && date.format('YYYY-MM-DD') <= end.format('YYYY-MM-DD'));    
        }
        return true;    
    };
    
    isHighlightedDates = (dateString: string) => {
        let styles: any = undefined;
        let date = moment(new Date(dateString));
        if(MarvDateService.IsPublicHolidays(date.toDate())){
            styles = {
                textColor: 'rgb(var(--marv-color-purple-contrast))',
                backgroundColor: 'rgba(var(--marv-color-purple), 0.4)',
                border: '1px solid rgba(var(--marv-color-purple), 0.6)',
            };
        }
        return styles;
    };
    
    openAdditionalsDatasModal(){        
        this.marvModalService.open(this.modalAdditionalsDatas);
    }
    
    closeAdditionalsDatasModal(){
        this.modalAdditionalsDatas.dismiss();
    }
    
    async canDismissAdditionalsDatasModal(data?: any, role?: string) {
        return role !== 'gesture';
    }
    
    onDidDismissAdditionalsDatasModal($event: any){
        this.marvModalService.onDidDismiss($event);
    }
    
    async onChangeAdditionalsDatas(data: any){
        this.additionalsDatas = data;
        if(this.additionalsDatas){
            this.additionalsDatasUpdated = true;
            this.lastModificationAdditionalsDatas = moment.unix(this.additionalsDatas.last_modification).utc().toDate();            
        }
        this.closeAdditionalsDatasModal();
    }
    
    async loadHourlyQuota(profilId: number): Promise<CustomerOrderQuota|null>{
        let customerOrderQuota: CustomerOrderQuota|null = null;
        if(this.orderDay.customerSectorId){
            customerOrderQuota = await this.operationService.loadHourlyQuotaStatus(this.orderDay.customerSectorId, profilId);
        }
        return customerOrderQuota;
    }
    
    async getDatesPreview(){
        let orderDay = OrderDay.FromForm(this.orderDay.getCopy(false), this.operation, this.operationPlanningSetting, this.showWorkersSuggestionList, this.addOrderDayForm, this.datesPreview, this.missionDetailsFile, this.contactSharingToWorkerAllowed); 
        let dates: Array<Date> = [];
        orderDay.datesResults.forEach(d => {            
            if(d.day){
                dates.push(d.day);
            }
        });       
        this.datesPreview = new DatesPreview(dates, this.datesPreview.addedDates, this.datesPreview.deletedDates);
    }
    
    async checkDateValue(): Promise<any> {
        if(this.orderDay){
            this.getDatesPreview();
            let planningComplientReport: MissionPlanningComplianceReport = new MissionPlanningComplianceReport();;
            let orderDay = this.orderDay.getCopy(false);        
            let newOrderDay = OrderDay.FromForm(orderDay, this.operation, this.operationPlanningSetting, this.showWorkersSuggestionList, this.addOrderDayForm, this.datesPreview, this.missionDetailsFile, this.contactSharingToWorkerAllowed);
            let data = OrderDay.ToOrdersRequests(newOrderDay, this.showWorkersSuggestionList, this.datesPreview);
            for(let orderRequest of data.ordersRequests){
                if(orderRequest.planning.length > 0){    
                    let report = await this.orderService.checkPlanningCompliance(orderRequest);      
                    if(report){                    
                        planningComplientReport.concatMessages(report);
                    }
                } 
            }
            this.planningComplientReport = planningComplientReport;
            await this.getWorkersSuggestionList(); 
        }
    }
    
    toggleRecurrence(enableRecurrence: boolean, periodicityDates: Map<number, number>, checkDateValue: boolean = true){
        this.datesPreview = new DatesPreview();
        for(let numDate of this.numsDates){
            if(enableRecurrence){
                this.addOrderDayForm.removeControl('day_'+numDate, {emitEvent: false});
                let s1 = this.updateDaySubscription.get(numDate);
                if(s1){
                    s1.unsubscribe();
                    this.updateDaySubscription.delete(numDate);
                }
                let periodicity = periodicityDates.get(numDate) || 1;
                this.addControlRecurrence(numDate, periodicity);
            }
            else{
                this.addOrderDayForm.addControl('day_'+numDate, new FormControl(null, [Validators.required]), {emitEvent: false});     
                this.updateDaySubscription.set(numDate, 
                    this.addOrderDayForm.controls['day_'+numDate].valueChanges.subscribe(value => { 
                        this.checkDateValue();
                    })
                );
                this.removeControlRecurrence(numDate);
            }
        }
        if(checkDateValue){
            this.checkDateValue();
        }
    }
    
    addControlRecurrence(numDate: number, periodicity: number){
        let startDate = moment();
        startDate.add(1, 'day');
        let endDate = moment(MarvDateService.GetLastDayOfMonth());
        let endDateMax = moment(this.endPlannableDate);
        if(endDate.format('YYYY-MM-DD') > endDateMax.format('YYYY-MM-DD')){
            endDate = endDateMax;
        }
        this.addOrderDayForm.addControl('periodicity_'+numDate, new FormControl(periodicity, [Validators.required]), {emitEvent: false});   
        this.addOrderDayForm.addControl('recurrence_start_date_'+numDate, new FormControl(startDate.toDate(), [Validators.required]), {emitEvent: false});   
        this.addOrderDayForm.addControl('recurrence_end_date_'+numDate, new FormControl(endDate.toDate(), [Validators.required]), {emitEvent: false});   
        
        this.updateRecurrencePeriodicitySubscription.set(numDate, 
            this.addOrderDayForm.controls['periodicity_'+numDate].valueChanges.subscribe(value => { 
                if(this.addOrderDayForm.controls['periodicity_'+numDate].value === 1){
                    this.addControlRecurrenceWeekly(numDate);
                    this.removeControlRecurrenceMonthly(numDate);
                }
                else if(this.addOrderDayForm.controls['periodicity_'+numDate].value === 2){
                    this.addControlRecurrenceMonthly(numDate);
                    this.removeControlRecurrenceWeekly(numDate);
                }
                this.checkDateValue();
            })
        );
        
        this.updateRecurrenceStartDateSubscription.set(numDate, 
            this.addOrderDayForm.controls['recurrence_start_date_'+numDate].valueChanges.subscribe(value => {
                this.checkDateValue();
            })
        );
        
        this.updateRecurrenceEndDateSubscription.set(numDate, 
            this.addOrderDayForm.controls['recurrence_end_date_'+numDate].valueChanges.subscribe(value => {
                this.checkDateValue();
            })
        );
                      
        switch(periodicity){ 
            case 1:
                this.addControlRecurrenceWeekly(numDate);  
                break;     
            case 2:
                this.addControlRecurrenceMonthly(numDate);  
                break;   
        }  
    }
    
    removeControlRecurrence(numDate: number){
        
        this.removeControlRecurrenceWeekly(numDate);
        this.removeControlRecurrenceMonthly(numDate);
        
        this.addOrderDayForm.removeControl('periodicity_'+numDate, {emitEvent: false});   
        this.addOrderDayForm.removeControl('recurrence_start_date_'+numDate, {emitEvent: false});   
        this.addOrderDayForm.removeControl('recurrence_end_date_'+numDate, {emitEvent: false});   
                
        let s1 = this.updateRecurrencePeriodicitySubscription.get(numDate);
        if(s1){
            s1.unsubscribe();
            this.updateRecurrencePeriodicitySubscription.delete(numDate);
        }            
        
        let s2 = this.updateRecurrenceStartDateSubscription.get(numDate);
        if(s2){
            s2.unsubscribe();
            this.updateRecurrenceStartDateSubscription.delete(numDate);
        }            
        
        let s3 = this.updateRecurrenceEndDateSubscription.get(numDate);
        if(s3){
            s3.unsubscribe();
            this.updateRecurrenceEndDateSubscription.delete(numDate);
        }            
        
    }
    
    addControlRecurrenceWeekly(numDate: number){
        
        this.addOrderDayForm.addControl('weekly_recurrence_'+numDate, new FormControl(1, [Validators.required]), {emitEvent: false});         
        
        this.updateWeeklyRecurrenceSubscription.set(numDate, 
            this.addOrderDayForm.controls['weekly_recurrence_'+numDate].valueChanges.subscribe(value => {
                this.checkDateValue();
            })
        );
        
        for(let wd of this.weekDays){
            this.addOrderDayForm.addControl('weekly_day_'+numDate+'_'+wd.numDay, new FormControl(moment().isoWeekday() === wd.numDay), {emitEvent: false}); 
            
            this.updateWeeklyRecurrenceDaySubscription.set(numDate+'_'+wd.numDay, 
                this.addOrderDayForm.controls['weekly_day_'+numDate+'_'+wd.numDay].valueChanges.subscribe(value => {
                    this.checkDateValue();
                })
            );
            
        }  
    }
    
    removeControlRecurrenceWeekly(numDate: number){
        
        this.addOrderDayForm.removeControl('weekly_recurrence_'+numDate, {emitEvent: false});  
        
        let s1 = this.updateWeeklyRecurrenceSubscription.get(numDate);
        if(s1){
            s1.unsubscribe();
            this.updateWeeklyRecurrenceSubscription.delete(numDate);
        }
                
        for(let wd of this.weekDays){
            this.addOrderDayForm.removeControl('weekly_day_'+numDate+'_'+wd.numDay, {emitEvent: false}); 
            
            let s = this.updateWeeklyRecurrenceDaySubscription.get(numDate+'_'+wd.numDay);
            if(s){
                s.unsubscribe();
                this.updateWeeklyRecurrenceDaySubscription.delete(numDate+'_'+wd.numDay);
            }
        } 
    }
    
    addControlRecurrenceMonthly(numDate: number){
        
        this.addOrderDayForm.addControl('monthly_recurrence_day_num_'+numDate, new FormControl(1, [Validators.required]), {emitEvent: false}); 
        this.addOrderDayForm.addControl('monthly_recurrence_day_'+numDate, new FormControl(moment().isoWeekday(), [Validators.required]), {emitEvent: false}); 
        this.addOrderDayForm.addControl('monthly_recurrence_month_'+numDate, new FormControl(1, [Validators.required]), {emitEvent: false});
        
        this.updateMonthlyRecurrenceNumDaySubscription.set(numDate, 
            this.addOrderDayForm.controls['monthly_recurrence_day_num_'+numDate].valueChanges.subscribe(value => {
                this.checkDateValue();
            })
        );
        
        this.updateMonthlyRecurrenceDaySubscription.set(numDate, 
            this.addOrderDayForm.controls['monthly_recurrence_day_'+numDate].valueChanges.subscribe(value => {
                this.checkDateValue();
            })
        );
        
        this.updateMonthlyRecurrenceMonthSubscription.set(numDate, 
            this.addOrderDayForm.controls['monthly_recurrence_month_'+numDate].valueChanges.subscribe(value => {
                this.checkDateValue();
            })
        );
                 
    }
    
    removeControlRecurrenceMonthly(numDate: number){
        this.addOrderDayForm.removeControl('monthly_recurrence_day_num_'+numDate, {emitEvent: false});  
        this.addOrderDayForm.removeControl('monthly_recurrence_day_'+numDate, {emitEvent: false});  
        this.addOrderDayForm.removeControl('monthly_recurrence_month_'+numDate, {emitEvent: false});  
        
        let s1 = this.updateMonthlyRecurrenceNumDaySubscription.get(numDate);
        if(s1){
            s1.unsubscribe();
            this.updateMonthlyRecurrenceNumDaySubscription.delete(numDate);
        }
        
        let s2 = this.updateMonthlyRecurrenceDaySubscription.get(numDate);
        if(s2){
            s2.unsubscribe();
            this.updateMonthlyRecurrenceDaySubscription.delete(numDate);
        }
        
        let s3 = this.updateMonthlyRecurrenceMonthSubscription.get(numDate);
        if(s3){
            s3.unsubscribe();
            this.updateMonthlyRecurrenceMonthSubscription.delete(numDate);
        }
        
    }
    
    getTimeFix(){
        let amStartTimeDefault = null;        
        let amDurationDefault = null;
        let pmStartTimeDefault = null;       
        let pmDurationDefault = null;
        
        if(this.operationPlanningSetting.hasTimeFix()){
            let date: Date = new Date();
            
            date.setHours(this.operationPlanningSetting.amStartTime, 0, 0, 0);
            amStartTimeDefault = moment(date).format("HH:mm");
            amDurationDefault = (this.operationPlanningSetting.amEndTime - this.operationPlanningSetting.amStartTime) * 60;
            
            date.setHours(this.operationPlanningSetting.pmStartTime, 0, 0, 0);
            pmStartTimeDefault = moment(date).format("HH:mm");
            pmDurationDefault = (this.operationPlanningSetting.pmEndTime - this.operationPlanningSetting.pmStartTime) * 60;
        }
        
        return {amStartTime: amStartTimeDefault, amDuration: amDurationDefault, pmStartTime: pmStartTimeDefault, pmDuration: pmDurationDefault};
    }
        
    setNbDaysForm(nbDays: number, enableRecurrence: boolean, datesConf: Array<OrderDayDateConf>|null = null){
        
        let defautTime = this.getTimeFix();
                
        if(nbDays >= 0){
            let numsDatesLength = this.numsDates.length;
            if(nbDays < numsDatesLength){
                for(let i=(numsDatesLength-1);i>=nbDays;i--){
                    let numDate = (i+1);
                    this.numsDates.splice(i,1);
                    
                    if(enableRecurrence){
                        this.removeControlRecurrence(numDate);
                    }
                    else{
                        this.addOrderDayForm.removeControl('day_'+numDate, {emitEvent: false});
                        let s1 = this.updateDaySubscription.get(numDate);
                        if(s1){
                            s1.unsubscribe();
                            this.updateDaySubscription.delete(numDate);
                        }
                    }
                    
                    this.hoursEntrySelected.delete(numDate);
                    
                    this.addOrderDayForm.removeControl('startTimeMin_'+numDate, {emitEvent: false});
                    this.addOrderDayForm.removeControl('startTimeMax_'+numDate, {emitEvent: false});
                    this.addOrderDayForm.removeControl('timeMorning_'+numDate, {emitEvent: false});
                    this.addOrderDayForm.removeControl('durationMorning_'+numDate, {emitEvent: false});
                    this.addOrderDayForm.removeControl('timeAfternoon_'+numDate, {emitEvent: false});
                    this.addOrderDayForm.removeControl('durationAfternoon_'+numDate, {emitEvent: false});
                    this.addOrderDayForm.removeControl('hoursEntry_'+numDate, {emitEvent: false});
                                        
                    let s2 = this.updateStartTimeMinSubscription.get(numDate);
                    if(s2){
                        s2.unsubscribe();
                        this.updateStartTimeMinSubscription.delete(numDate);
                    }
                    let s3 = this.updateStartTimeMaxSubscription.get(numDate);
                    if(s3){
                        s3.unsubscribe();
                        this.updateStartTimeMaxSubscription.delete(numDate);
                    }
                    let s4 = this.updateTimeMorningSubscription.get(numDate);
                    if(s4){
                        s4.unsubscribe();
                        this.updateTimeMorningSubscription.delete(numDate);
                    }
                    let s5 = this.updateDurationMorningSubscription.get(numDate);
                    if(s5){
                        s5.unsubscribe();
                        this.updateDurationMorningSubscription.delete(numDate);
                    }
                    let s6 = this.updateTimeAfternoonSubscription.get(numDate);
                    if(s6){
                        s6.unsubscribe();
                        this.updateTimeAfternoonSubscription.delete(numDate);
                    }
                    let s7 = this.updateDurationAfternoonSubscription.get(numDate);
                    if(s7){
                        s7.unsubscribe();
                        this.updateDurationAfternoonSubscription.delete(numDate);
                    }
                }
            }
            else{
                for(let i=numsDatesLength;i<nbDays;i++){
                    let numDate = (i+1);
                    this.numsDates[i] = numDate;
                    
                    if(enableRecurrence){                       
                        let periodicity = 1;
                        if(this.addOrderDayForm.controls['periodicity_'+numDate]){
                            periodicity = this.addOrderDayForm.controls['periodicity_'+numDate].value;
                        }
                        else if(datesConf && typeof datesConf[i] !== 'undefined' && datesConf[i].recurrence){
                            periodicity = datesConf[i]?.recurrence?.periodicity || 1;
                        }
                        this.addControlRecurrence(numDate, periodicity);
                    }
                    else{
                        this.addOrderDayForm.addControl('day_'+numDate, new FormControl(null, [Validators.required]), {emitEvent: false});     
                        this.updateDaySubscription.set(numDate, 
                            this.addOrderDayForm.controls['day_'+numDate].valueChanges.subscribe(value => { 
                                this.checkDateValue();
                            })
                        );
                    }
                    
                    let amDuration = defautTime.amDuration
                    if(this.operation.typeOfMission.code != environment.MISSION_TYPE_ANIM){
                        if(this.operationPlanningSetting?.mandatoryMissionDurationInHours){
                            amDuration = this.operationPlanningSetting.mandatoryMissionDurationInHours*60;
                        }
                        else if(amDuration === null && this.dayOrderDurationEstimated > 0){
                            amDuration = this.dayOrderDurationEstimated;
                        }
                    }
                                       
                    this.hoursEntrySelected.set(numDate, 'IMPOSED'); 
                                        
                    this.addOrderDayForm.addControl('startTimeMin_'+numDate, new FormControl(null), {emitEvent: false});
                    this.addOrderDayForm.addControl('startTimeMax_'+numDate, new FormControl(null), {emitEvent: false});
                    this.addOrderDayForm.addControl('timeMorning_'+numDate, new FormControl(defautTime.amStartTime), {emitEvent: false});
                    this.addOrderDayForm.addControl('durationMorning_'+numDate, new FormControl(amDuration), {emitEvent: false});
                    this.addOrderDayForm.addControl('timeAfternoon_'+numDate, new FormControl(defautTime.pmStartTime), {emitEvent: false});
                    this.addOrderDayForm.addControl('durationAfternoon_'+numDate, new FormControl(defautTime.pmDuration), {emitEvent: false});
                    this.addOrderDayForm.addControl('hoursEntry_'+numDate, new FormControl('IMPOSED'), {emitEvent: false});
                      
                    this.setValidatorsHours(numDate);     
                                           
                    this.updateStartTimeMinSubscription.set(numDate,
                        this.addOrderDayForm.controls['startTimeMin_'+numDate].valueChanges.subscribe(value => {    
                            this.calculateEstimatedEndHour(numDate);
                        })
                    );
                                           
                    this.updateStartTimeMaxSubscription.set(numDate,
                        this.addOrderDayForm.controls['startTimeMax_'+numDate].valueChanges.subscribe(value => {    
                            this.calculateEstimatedEndHour(numDate);
                        })
                    );
                                           
                    this.updateTimeMorningSubscription.set(numDate,
                        this.addOrderDayForm.controls['timeMorning_'+numDate].valueChanges.subscribe(value => {    
                            this.checkDateValue();
                        })
                    );

                    this.updateDurationMorningSubscription.set(numDate,
                        this.addOrderDayForm.controls['durationMorning_'+numDate].valueChanges.subscribe(value => {              
                            this.checkDateValue();
                            if(this.hoursEntrySelected.get(numDate) === 'SUGGESTED'){
                                this.calculateEstimatedEndHour(numDate);
                            }
                        })
                    );

                    this.updateTimeAfternoonSubscription.set(numDate,
                        this.addOrderDayForm.controls['timeAfternoon_'+numDate].valueChanges.subscribe(value => {                      
                            this.checkDateValue();
                        })
                    );

                    this.updateDurationAfternoonSubscription.set(numDate,
                        this.addOrderDayForm.controls['durationAfternoon_'+numDate].valueChanges.subscribe(value => {                      
                            this.checkDateValue();
                        })
                    );
                    
                }
            }
        }          
    }
    
    prefillNbAgents(){            
        let idElement = this.addOrderDayForm.controls['merchImplementationOption']?.value;
        let exist = this.operationPlanningSetting.merchImplementationOptions.find(e => e.id === idElement);
        if(exist && exist.suggestedNbOfAgents > 0){
            this.addOrderDayForm.controls['nbAgents'].setValue(exist.suggestedNbOfAgents, {emitEvent: false});
            this.setNbAgentsForm(exist.suggestedNbOfAgents);  
            this.nbWorkersRecommended = exist.suggestedNbOfAgents;     
        }     
        else{
            this.nbWorkersRecommended = 0;
        }  
    }
    
    setNbAgentsForm(nbAgents: number){        
        if(nbAgents >= 0){
            let numsAgentsLength = this.numsAgents.length;
            if(nbAgents < numsAgentsLength){
                for(let i=(numsAgentsLength-1);i>=nbAgents;i--){
                    let numAgent = (i+1);
                    this.numsAgents.splice(i,1);
                    this.addOrderDayForm.removeControl('agentProfil_'+numAgent, {emitEvent: false});
                    this.addOrderDayForm.removeControl('agentsSuggestionIds_'+numAgent, {emitEvent: false});
                    this.addOrderDayForm.removeControl('agentSuggestion_'+numAgent, {emitEvent: false});
                }
            }
            else{                
                for(let i=numsAgentsLength;i<nbAgents;i++){
                    let numAgent = (i+1);
                    this.numsAgents[i] = numAgent;
                    this.addOrderDayForm.addControl('agentProfil_'+numAgent, new FormControl((this.agentsProfils.length === 1 ? this.agentsProfils[0].value : null), [Validators.required]), {emitEvent: false});     
                    this.addOrderDayForm.addControl('agentsSuggestionIds_'+numAgent, new FormControl([]), {emitEvent: false});
                    this.addOrderDayForm.addControl('agentSuggestion_'+numAgent, new FormControl(null), {emitEvent: false});
                }
            }
        }        
    }
    
    enableMultipleGoal(goalId: number){
        if(!this.disabledForm){
            this.addOrderDayForm.controls['enableMultipleGoal_'+goalId].setValue(!this.addOrderDayForm.controls['enableMultipleGoal_'+goalId].value);
        }
    }
    
    calculateEstimatedTime(){       
        if(!this.operationPlanningSetting?.mandatoryMissionDurationInHours){            
            let minutes: number = 0;   
            let enforceDayOrderDurationEstimated = false;      
            if(this.operationPlanningSetting && this.operationPlanningSetting.missionPlanningPurposes.length > 0){
                if(this.operationPlanningSetting.useMultiPurposePlanning){
                    this.operationPlanningSetting.missionPlanningPurposes.forEach(p => {
                        if(this.addOrderDayForm.controls['enableMultipleGoal_'+p.id].value){
                            if(p.recommendedDurationInMinutes){
                                minutes += p.recommendedDurationInMinutes;
                            }
                        }
                    });
                }           
                else {     
                    let goal = this.operationPlanningSetting.missionPlanningPurposes.find(p => p.id == this.addOrderDayForm.controls['uniqueGoal'].value);
                    if(goal?.recommendedDurationInMinutes){
                        minutes = goal.recommendedDurationInMinutes;
                    } 
                }
            }
            if(minutes > 0){
                this.dayOrderDurationEstimatedStr = MarvDateService.MinutesToStr(minutes, 'H');            
                let newDuration: number = 0;
                let defautTime = this.getTimeFix();
                if(defautTime.amDuration === null && this.operation.typeOfMission.code != environment.MISSION_TYPE_ANIM){                
                    for(let d of this.durations){
                        if(parseInt(d.value.toString()) >= minutes){
                            newDuration = parseInt(d.value.toString());
                            break;
                        }
                    }
                    if(newDuration > 0){
                        for(let numDate of this.numsDates){
                            this.addOrderDayForm.controls['durationMorning_'+numDate].setValue(newDuration, {emitEvent: false});
                        }
                    }
                }
                this.dayOrderDurationEstimated = newDuration;
                enforceDayOrderDurationEstimated = this.operationPlanningSetting.enforcePurposeRecommendedDuration;
            }
            else{
                this.dayOrderDurationEstimated = 0;
                this.dayOrderDurationEstimatedStr = '';
            }
            this.enforceDayOrderDurationEstimated = enforceDayOrderDurationEstimated;
        }
    }
    
    calculateEstimatedEndHour(numDate: number){
        let dayOrderEndHourEstimatedStr = '';
        
        let startTimeMin = this.addOrderDayForm.controls['startTimeMin_'+numDate].value;
        let startTimeMax = this.addOrderDayForm.controls['startTimeMax_'+numDate].value;
        let durationMorning = this.addOrderDayForm.controls['durationMorning_'+numDate].value;
        
        if(startTimeMin !== null && startTimeMax !== null && durationMorning !== null){
            let endTimeMin = MarvDateService.MinutesToStr(MarvDateService.StrToMinutes(startTimeMin) + durationMorning, 'H');
            let endTimeMax = MarvDateService.MinutesToStr(MarvDateService.StrToMinutes(startTimeMax) + durationMorning, 'H');
            dayOrderEndHourEstimatedStr = this.translateService.instant('MSG_ESTIMATED_END_HOUR').replace('#end_time_min#', endTimeMin).replace('#end_time_max#', endTimeMax);
        }
        
        this.dayOrderEndHourEstimatedStr = dayOrderEndHourEstimatedStr;
    }        
    
    setValidatorsHours(numDate: number){
        if(this.operation.typeOfMission.code != environment.MISSION_TYPE_ANIM){            
            if(this.hoursEntrySelected.get(numDate) === 'SUGGESTED'){
                this.addOrderDayForm.controls['startTimeMin_'+numDate].addValidators(Validators.required);
                this.addOrderDayForm.controls['startTimeMax_'+numDate].addValidators(Validators.required);
                this.addOrderDayForm.controls['durationMorning_'+numDate].addValidators(Validators.required);
                this.addOrderDayForm.controls['timeMorning_'+numDate].removeValidators(Validators.required);
            }
            else{
                this.addOrderDayForm.controls['timeMorning_'+numDate].addValidators(Validators.required);
                this.addOrderDayForm.controls['durationMorning_'+numDate].addValidators(Validators.required);
                this.addOrderDayForm.controls['startTimeMin_'+numDate].removeValidators(Validators.required);
                this.addOrderDayForm.controls['startTimeMax_'+numDate].removeValidators(Validators.required);
            }   
            this.addOrderDayForm.controls['startTimeMin_'+numDate].updateValueAndValidity();
            this.addOrderDayForm.controls['startTimeMax_'+numDate].updateValueAndValidity();
            this.addOrderDayForm.controls['durationMorning_'+numDate].updateValueAndValidity();
            this.addOrderDayForm.controls['timeMorning_'+numDate].updateValueAndValidity();
        }
    }
    
    selectHoursEntry(numDate: number, hoursEntry: 'IMPOSED'|'SUGGESTED') {
        this.hoursEntrySelected.set(numDate, hoursEntry);
        this.addOrderDayForm.controls['hoursEntry_'+numDate].setValue(hoursEntry, {emitEvent: false});
                
        this.addOrderDayForm.controls['startTimeMin_'+numDate].setValue(null, {emitEvent: false});
        this.addOrderDayForm.controls['startTimeMax_'+numDate].setValue(null, {emitEvent: false});
        this.addOrderDayForm.controls['timeMorning_'+numDate].setValue(null, {emitEvent: false});
        this.addOrderDayForm.controls['timeAfternoon_'+numDate].setValue(null, {emitEvent: false});
        this.addOrderDayForm.controls['durationAfternoon_'+numDate].setValue(null, {emitEvent: false});
        
        this.setValidatorsHours(numDate);        
    }
    
    isDisabledValidate(): boolean{
        return (!this.addOrderDayForm.valid 
            || this.orderDay.store === null
            || !this.checkPurposePlanning()
            || !this.planningComplientReport.planningCompliance
            || (this.addOrderDayForm.controls['enableRecurrence'] && this.datesPreview.finalDates.length === 0)
        );
    }
    
    async displayErrorMessage(title: string, message: string){
        const alert = await this.alertController.create({
            header: title,           
            message: message,
            buttons: [this.translateService.instant('CLOSE')],
        });
        await alert.present();
    }
    
    async checkPrefillNbAgents(){
        return new Promise(async(resolve) => {
            
            let nbWorkers = this.addOrderDayForm.controls['nbAgents'].value;
            let idElement = this.addOrderDayForm.controls['merchImplementationOption']?.value;
            let exist = this.operationPlanningSetting.merchImplementationOptions.find(e => e.id === idElement);
            
            if(!this.disabledUpdate && exist && exist.suggestedNbOfAgents > 0 && nbWorkers < exist.suggestedNbOfAgents){            
                const alert = await this.alertController.create({
                    header: this.translateService.instant('CONFIRM_NB_WORKERS'),           
                    message: this.translateService.instant('MSG_CONFIRM_PREFILL_NB_WORKERS').replace('#nb_workers_prefill#', exist.suggestedNbOfAgents).replace('#nb_workers#', nbWorkers),
                    buttons: [{
                        text: this.translateService.instant('CONFIRM_MY_ORDER'),
                        role: 'confirm',
                        handler: () => {
                            resolve(true);
                        },
                    },
                    {
                        text: this.translateService.instant('MODIFY_MY_ORDER'),
                        role: 'cancel' ,
                        handler: () => {
                            resolve(false);
                        }     
                    }],
                });
                await alert.present();
            }
            else{
                resolve(true);
            }
        });
    }
    
    async getWorkersSuggestionList(){
        
        let showWorkersSuggestionList: boolean = false;
        let workersSuggestionItem: Array<MarvSelectItem> = [];
        let workersSuggestionMessageInfo: string = '';
        
        let nbAgents = (this.addOrderDayForm.controls['nbAgents'].value || 0);
        let oldWorkersSuggestionIds: Map<number, Array<number>> = new Map();
        for(let numAgent=1;numAgent<=nbAgents;numAgent++){
            oldWorkersSuggestionIds.set(numAgent, this.addOrderDayForm.controls['agentsSuggestionIds_'+numAgent]?.value || []);
        }
        
        if(this.operation?.id && this.store?.id && this.datesPreview.finalDates.length > 0){
            let epochDays: Array<number> = [];
            for(let d of this.datesPreview.finalDates){
                let epochDay = MarvDateService.FromDate(d);
                if(epochDay !== null){
                    epochDays.push(epochDay);
                }
            }
            let workersSuggestionReport = await this.orderService.loadWorkersSuggestionList(this.operation.id, this.store.id, epochDays);
            showWorkersSuggestionList = workersSuggestionReport.showReport;
            workersSuggestionMessageInfo = workersSuggestionReport.message;
            if(workersSuggestionReport.candidates.length > 0){
                for(let c of workersSuggestionReport.candidates){
                    workersSuggestionItem.push(new MarvSelectItem(c.firstName+' '+c.lastName, c.workerId));
                }
            }
        }
        
        this.showWorkersSuggestionList = showWorkersSuggestionList;
        this.workersSuggestionItem = workersSuggestionItem;
        this.workersSuggestionMessageInfo = workersSuggestionMessageInfo;
        
        for(let numAgent=1;numAgent<=nbAgents;numAgent++){
            let newWorkersIds = [];
            let workersIds = oldWorkersSuggestionIds.get(numAgent) || [];
            if(workersIds.length > 0){
                for(let id of workersIds){
                    if(this.workersSuggestionItem.find(i => i.value === id)){
                        newWorkersIds.push(id);
                    }
                }
            }
            if(this.addOrderDayForm.controls['agentsSuggestionIds_'+numAgent]){
                this.addOrderDayForm.controls['agentsSuggestionIds_'+numAgent].setValue(newWorkersIds, {emitEvent: false});
            }
        }
        
    }
    
    async saveOrderDay(){      
        if(this.disabledForm){
            return;
        }
        
        this.isFetchingSave = true;
        
        if(this.addOrderDayForm.valid){
            let orderDayId = this.orderDay?.id || null;
            this.checkDateValue();
            if(!this.isDisabledValidate()){
                
                let confirmOrder = await this.checkPrefillNbAgents();
                
                if(confirmOrder){
                
                    let orderDay = OrderDay.FromForm(this.orderDay, this.operation, this.operationPlanningSetting, this.showWorkersSuggestionList, this.addOrderDayForm, this.datesPreview, this.missionDetailsFile, this.contactSharingToWorkerAllowed);
                    
                    let cptOrderSuccess = 0;
                    let cptRequests = 0;
                    let errorProcess = false;    
                    let tabOrdersIds: Array<number> = [];
                    for(let numAgent of orderDay.ordersRequestsByAgents.keys()){                                      
                        let tabOrdersRequest = orderDay.ordersRequestsByAgents.get(numAgent);
                        if(tabOrdersRequest){
                            cptRequests += tabOrdersRequest.length;
                            for(let o of tabOrdersRequest){
                                let status = new OrderDayProcessStatus();
                                if(!orderDay.orderId){
                                    status = await this.addOrder(o);
                                }
                                else{
                                    status = await this.updateOrder(orderDay.orderId, o);
                                }
                                if(!status.error){                                    
                                    tabOrdersIds = tabOrdersIds.concat(status.ordersIds);
                                    for(let orderId of status.ordersIds){
                                        
                                        if(this.additionalsDatas !== null){
                                            await this.orderService.saveAdditionalsDatas(orderId, this.additionalsDatas);
                                            if(this.additionalsDatasUpdated && orderDay.store && !orderDay.orderId){
                                                await this.storeService.saveAdditionalsDatas(this.operation.id, orderDay.store.id, this.additionalsDatas);
                                            }
                                        }
                                        
                                        let res = await this.sendBriefMission(orderId);
                                        if(!res){
                                            const toast = await this.toastController.create({
                                                message: this.translateService.instant('MSG_ERROR_ORDER_SEND_BRIEF'),
                                                duration: 6000,
                                                position: 'top',
                                                color: 'danger'
                                            });
                                            await toast.present();
                                            errorProcess = true;
                                            break;                                           
                                        }
                                    }     
                                    
                                    if(errorProcess){
                                        break;
                                    }
                                                                   
                                    cptOrderSuccess++;                                    
                                } 
                                else{
                                    const toast = await this.toastController.create({
                                        message: status.msgError,
                                        duration: 6000,
                                        position: 'top',
                                        color: 'danger'
                                    });
                                    await toast.present();
                                    errorProcess = true;
                                    break;
                                }                           
                            }
                            orderDay.ordersRequestsByAgents.set(numAgent, tabOrdersRequest);
                        }
                        
                        if(errorProcess){
                            break;
                        }
                    }

                    if(!errorProcess && cptRequests === cptOrderSuccess){
                        orderDay.tabOrdersIds = tabOrdersIds;
                        const toast = await this.toastController.create({
                            message: (tabOrdersIds.length > 1 ? this.translateService.instant('MSG_SUCCESS_PROCESS_ORDERS') : this.translateService.instant('MSG_SUCCESS_PROCESS_ORDER')),
                            duration: 6000,
                            position: 'top',
                            color: 'success'
                        });
                        await toast.present();
                        orderDay.disabled = true;
                        this.emitChange(orderDay); 
                    }
                    else{     
                        if(tabOrdersIds.length > 0){
                            for(let id of tabOrdersIds){
                                await this.orderService.deleteOrder(id);
                            }
                        }
                    }                    
                }
            }
        }
        else{
            for (var controlName in this.addOrderDayForm.controls) {
                if(!this.addOrderDayForm.controls[controlName].valid) {
                    this.addOrderDayForm.controls[controlName].markAsTouched();
                }
            }
        }
        this.isFetchingSave = false;
    }
    
    async addOrder(orderRequest: OrderRequest): Promise<OrderDayProcessStatus>{
        let status = new OrderDayProcessStatus();
        let report = await this.orderService.checkPlanningCompliance(orderRequest);
        if (report){
            if (report.planningCompliance){
                let createResponse = await this.orderService.createOrder(orderRequest);
                if(createResponse?.missions && !createResponse?.quotaExceed){
                    status.ordersIds = createResponse.missions;
                    status.error = false;
                }
                else if(createResponse?.quotaExceed){
                    let msgError = this.translateService.instant('MSG_ERROR_CREATE_ORDER_QUOTA')+'<br/><br/>';
                    if (createResponse.quotaExcededDetails == null || createResponse.quotaExcededDetails.length < 1){
                        msgError += this.translateService.instant('MSG_ERROR_CREATE_ORDER_QUOTA_AVAILABLE')      
                            . replace('#nb_hours_available#', Math.round((createResponse.quota - createResponse.currentQuota) * 10) / 10);
                    }
                    else{
                        msgError += createResponse.quotaExcededDetails;
                    }                    
                    status.msgError = msgError
                }
                else{
                    status.msgError = this.translateService.instant('MSG_ERROR_CREATE_ORDER');
                }                
            }
            else{
                this.planningComplientReport.concatMessages(report);
            }
        }
        return status;
    }
        
    async updateOrder(orderId: number, orderRequest: OrderRequest): Promise<OrderDayProcessStatus>{
        let status = new OrderDayProcessStatus();
        let updateResponse = await this.orderService.updateOrder(orderId, orderRequest);
        if(updateResponse){
            if(updateResponse.quotaExceed){
                let msgError = this.translateService.instant('MSG_ERROR_UPDATE_ORDER_QUOTA');
                status.msgError = msgError
            }
            else{
                status.ordersIds = [orderId];
                status.error = false;
            }
        }
        else{
            status.msgError = this.translateService.instant('MSG_ERROR_UPDATE_ORDER');
        }        
        return status;
    }
    
    async sendBriefMission(orderId: number): Promise<boolean>{
        let briefStatus = true;
        if(this.missionDetailsFile?.filedata){
            let arrayBuffer = await this.missionDetailsFile.filedata.arrayBuffer();
            let metadata = {
                type: this.missionDetailsFile.filedata.type,
                name: this.missionDetailsFile.filedata.name
            };
            let briefResponse = await this.orderService.uploadClientBriefMission(orderId, arrayBuffer, metadata);
            if(!briefResponse){
                briefStatus = false;                
            }
            
        }
        return briefStatus;
    }
    
    cancelAddDayOrder(){     
        this.emitChange(null);           
    }
    
    emitChange(orderDay: OrderDay|null){
        // Reset Form Day        
        this.setNbDaysForm(0, this.addOrderDayForm.controls['enableRecurrence'].value);   
        this.toggleRecurrence(false, new Map<number, number>, false); 
        this.addOrderDayForm.reset();       
        this.missionDetailsFile = null;
        this.planningComplientReport = new MissionPlanningComplianceReport();
        this.dayOrderDurationEstimated = 0;
        this.dayOrderDurationEstimatedStr = '';
        this.numsDates = [];
        this.numsAgents = [];
        this.onChangeOrderDay.emit(orderDay);
    }
    
}
